var _style, _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgNavReplacement = function SvgNavReplacement(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 841.9 841.9",
    color: "#44ade2",
    style: {
      enableBackground: "new 0 0 841.9 841.9"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{fill:#231F20;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M320.4,531.4c-6.6-6.6-10.3-15.6-10.3-24.9V95.9h-223V755h673.2V541.6l-414.9,0.1 C336,541.7,327,538,320.4,531.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M453.6,147.2l0,217.9c0.1,19.8,16.2,35.8,36,35.8c0,0,0.1,0,0.1,0h218h0.8l0.8,0.1c9.6,0.9,18.9-2.1,26.3-8.2 c7.4-6.2,11.9-14.8,12.8-24.4c1.8-19.8-12.9-37.3-32.6-39c-2.1-0.2-4.3-0.2-6.4,0l-0.8,0.1H576L812.9,93 c6.8-6.8,10.6-15.9,10.6-25.5s-3.8-18.7-10.6-25.5c-14.1-14.1-37-14.1-51.1,0L525.5,278.9l0-132.1c0.2-9.6-3.3-18.7-10-25.7 c-6.6-6.9-15.6-10.9-25.2-11.1c-19.9-0.4-36.3,15.4-36.7,35.2c0,0.5,0,1,0,1.5L453.6,147.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M820.5,481.4c-6.6-6.6-15.6-10.3-24.9-10.3l-414.9,0.1V60.7c0-19.5-15.8-35.3-35.3-35.3H51.8 c-19.5,0-35.3,15.8-35.3,35.3v729.6c0,19.5,15.8,35.3,35.3,35.3h743.8c19.5,0,35.3-15.8,35.3-35.3v-284 C830.8,497,827.1,488,820.5,481.4z M760.3,755H87.1V95.9h223v410.5c0,9.4,3.7,18.3,10.3,24.9s15.6,10.3,24.9,10.3l414.9-0.1V755z"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNavReplacement, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/nav-replacement.b524af72.svg";
export { ForwardRef as ReactComponent };